import { Component, Input, OnInit } from '@angular/core';
import { ImporterService } from '../importer.service';
import { WSImport } from '../import.models';
import { LocalizationService } from '../../services/localization.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
    selector: 'app-pg-imported-widget',
    templateUrl: './pg-imported-widget.component.html',
    styleUrls: ['./pg-imported-widget.component.scss'],
    standalone: false
})
export class PgImportedWidgetComponent implements OnInit {

    constructor(private importerService:ImporterService, private localizationService:LocalizationService, private http:HttpClient) { }

    @Input() resourceId:string;
    @Input() elementId:string;

    importedJob:WSImport.Job = null;
    importedItem:WSImport.JobItem = null;
    importedProgress:WSImport.JobProgress = null;

    importedRealm = null;

    ngOnInit() {
        if(this.importerService.hasImporter()) {
            this.importerService.getLastImportJob(this.resourceId, this.elementId).subscribe((job) => {
                this.importedJob = job
    
                for(let i = 0; i < job.progress.length; i++) {
                    let _progress = job.progress[i];
    
                    if(_progress.tasks?.main.resource == this.resourceId && _progress.tasks?.main.element?.id == this.elementId) {
                        this.importedItem = job.items[i];
                        this.importedProgress = _progress;

                        if(this.importedJob.type == 'entourance' && _progress.element?.realm_id != null) {
                            this.http.get(this.importedJob.APIUrl + '/public/realm?limit=1000', {
                                headers: new HttpHeaders({ 'X-Interceptor-Silent': '*' })
                            }).subscribe((data:Array<any>) => {
                                for(let _realm of data) {
                                    if(_realm.id == _progress.element.realm_id) {
                                        this.importedRealm = _realm;
                                        break;
                                    }
                                }
                            }, () => {})
                        }

                        break;
                    }
                }
            })
        }
    }

    getImportTypeIcon(type) {
        switch(type) {
            case 'entourance': return 'fa-regular fa-server';
            case 'file': return 'fa-regular fa-file-spreadsheet';
            case 'wordpress': return 'fa-brands fa-wordpress';
            case 'dhm': return 'fa-regular fa-gears';
            case 'eppoi': return 'fa-regular fa-map-location-dot';
        }
    }

    getImportInstallationName(url:string) {
        return url.replace(/^https:\/\/api\./, '').replace(/\/.*$/, '')
    }

    getImportedItemDisplay(item:WSImport.JobEntouranceItem|WSImport.JobWordPressItem|WSImport.JobDHMItem|WSImport.JobEPPOIItem) {
        return this.localizationService.translateResource(item.resource) + (item.id ? ' - ' + item.id : '')
    }
}
